import * as yup from "yup";
export default yup;
export const loginSchema = yup.object({
    login: yup.string().required(),
    password: yup.string().min(4).max(20).required(),
});
